/* eslint-disable jsx-a11y/anchor-is-valid */

import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import withIntegrationCardContext from 'hoc/withIntegrationCardContext';
import Slider from 'react-slick';

const Bugsnag = ({ sliderSettings }) => {
  const { img1 } = useStaticQuery(graphql`
    {
      img1: file(relativePath: { eq: "marketplace/bugsnag/1.png" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  `);
  const photos = [
    {
      img: img1.childImageSharp.gatsbyImageData,
      alt: 'Bugsnag Integration',
      title: 'Integrate Bugsnag with LiveSession',
    },
  ];
  return (
    <>
      <Slider {...sliderSettings(photos)} className="without-dots">
        <div>
          <GatsbyImage image={photos[0].img} alt={photos[0].alt} title={photos[0].title} />
        </div>
      </Slider>
      <div className="section">
        <h2>Overview</h2>
        <p>
          Bugsnag is a professional app to monitor app stability and report errors. The LiveSession
          integration makes the process even more effective:
        </p>
      </div>
      <div className="section">
        <h2>Benefits</h2>
        <ul className="checkmarks">
          <li>Direct access to session recordings from Bugsnag dashboard</li>
          <li>Access to all information in one place</li>
          <li>Ability to see where the error has occurred</li>
        </ul>
      </div>
      <h2>How to install</h2>
      <p>
        Just copy and paste a piece of code, as described in our{' '}
        <a href="/help/bugsnag-integration/">help center</a>.
      </p>
    </>
  );
};

export default withIntegrationCardContext(Bugsnag);

Bugsnag.propTypes = {
  sliderSettings: PropTypes.func.isRequired,
};
